export default __webpack_public_path__ + "static/media/wrinklesActive.e3693a88.svg";